import React, { FC, ReactNode } from 'react';
import Header from './Header/Header';
import Footer from './Footer/Footer';

type LayoutProps = {
    children: ReactNode;
};

const Layout: FC<LayoutProps> = ({ children }) => {
    return (
        <div>
            <Header />
                <main>{children}</main>
            <Footer />
        </div>
    );
};

export default Layout;